export const TOPICS = {
  LOCATION: {
    TRIP_DATA: "nextdev/vehicles/{serialNo}/info", // TOPIC: "nextdev/vehicles/+/info",
    //LIVE_LOCATION: "telematics/nextdev/vehicles/{serialNo}/vehicledata", // TOPIC: "telematics/nextdev/vehicles/+/vehicledata"
    LIVE_LOCATION:
      "nextdev/companionapp/listener/{serialNo}/livetrackingupdates",
  },
  ENGINE_TEMP_ALERT: "simulator/engine/temp/alert",
  TYRE_PRESSURE_ALERT: "simulator/tyre/pressure/alert",
};
